<div class="ui-stat-card" [ngClass]="'ui-stat-card--' + variant">
  <div class="ui-stat-card__content">
    <div class="ui-stat-card__label">{{ label }}</div>
    <div class="ui-stat-card__value">{{ value }}</div>
  </div>
  <div class="ui-stat-card__icon-wrap" [ngClass]="'ui-stat-card__icon-wrap--' + variant">
    <mat-icon>{{ icon }}</mat-icon>
  </div>
</div>
